module.exports = __webpack_public_path__ + "img/Success-Illustration@3x.488c15c9.png";